<template>
  <div class="flex items-center justify-center mb-4">
    <div
      class="w-full bg-white px-4 pt-2 rounded-md shadow border border-grey-300"
    >
      <div class="flex flex-wrap -mx-3 mb-6">
        <h2 class="px-4 pt-3 pb-2 text-gray-800 text-lg">{{ $t('frontend_groovemember_main_panel_add_comment') }}</h2>
        <div class="w-full md:w-full px-3 mb-2 mt-2">
          <textarea
            class="bg-gray-100 rounded border border-gray-400 leading-normal resize-none w-full h-20 py-2 px-3 font-medium placeholder-gray-700 focus:outline-none focus:bg-white"
            name="body"
            placeholder="Type Your Comment"
            required
          ></textarea>
        </div>
        <div class="w-full md:w-full flex items-start md:w-full px-3">
          <div class="flex items-start w-1/2 text-gray-700 px-2 mr-auto"></div>
          <div class="-mr-1">
            <input
              type="submit"
              class="text-white font-medium py-1 px-4 border border-gray-400 rounded-lg tracking-wide mr-1 bg-blue-500 hover:bg-blue-700"
              value="Comment"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddComment',
  props: ['isPreview'],
};
</script>